import styled from "styled-components";

export const Main = styled.div`
  width: 150px;
  padding: 0;
`;

export const Styled = styled.div`
  width: 425px;

  .authSelect {
    margin-bottom: 10px;
  }
  /* .section {
    margin-bottom: 12px;
  } */

  .row {
    display: flex;
    gap: 10px;
    align-items: center;
  }

  .row > * {
    flex: 1;
  }

  .muted {
    color: #6b7280;
    font-size: 13px;
    margin: 6px 0 0 0;
    line-height: 1.45;
  }

  .card {
    border: 1px solid #e5e7eb;
    border-radius: 10px;
    padding: 15px;
    background: #f9fafb;
  }

  .cardHeader {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
    margin-bottom: 6px;
  }

  .cardHeader h4 {
    margin: 0;
    font-size: 15px;
    font-weight: 500;
    color: #111827;
  }

  .badge {
    font-size: 12px;
    padding: 4px 8px;
    border-radius: 999px;
    border: 1px solid #e5e7eb;
    background: #fff;
    color: #374151;
    white-space: nowrap;
  }

  .badge.connected {
    border-color: #10b98155;
    background: #10b98115;
    color: #065f46;
  }

  .badge.disconnected {
    border-color: #f59e0b55;
    background: #f59e0b15;
    color: #92400e;
  }

  .monoBox {
    border: 1px solid #e5e7eb;
    border-radius: 8px;
    padding: 8px;
    background: #fff;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
    cursor: pointer;
  }

  .monoValue {
    font-family: "Monaco", "Menlo", "Ubuntu Mono", monospace;
    font-size: 13px;
    color: #111827;
    word-break: break-all;
    overflow-wrap: anywhere;
    flex: 1;
    min-width: 0;
  }

  .copyIcon {
    color: #6b7280;
    font-size: 12px;
    flex-shrink: 0;
  }

  .copyIcon.copied {
    color: #323432;
  }

  .folderList .btn1.active {
    background: #323432;
    color: #fff;
    border-color: #323432;
  }
    .triggerbtn1 .withBorder{
    background-color: transparent;
    color: #323432;
    border-color: #323432;
    }

  .buttons {
    display: flex;
    gap: 10px;
    margin-top: 10px;
  }

  .buttons button {
    flex: 1;
  }

  .statusText {
    margin-top: 8px;
    font-size: 13px;
    line-height: 1.3;
    white-space: pre-wrap;
    word-break: break-word;
  }

  .statusText.error {
    color: #b91c1c;
  }

  .statusText.success {
    color: #065f46;
  }

  .statusGrid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 8px;
    margin-top: 8px;
    font-size: 13px;
  }

  .statusItem {
    display: flex;
    justify-content: space-between;
    gap: 8px;
    padding: 6px 8px;
    border-radius: 8px;
    background: #fff;
    border: 1px solid #e5e7eb;
  }

  .statusItem span:first-child {
    color: #6b7280;
  }

  .secretRow {
    display: flex;
    gap: 10px;
    align-items: center;
    margin-top: 10px;
  }

  .secretRow label {
    width: 90px;
    font-weight: 400;
    white-space: nowrap;
    font-size: 15px;
  }

  .secretInputWrap {
    position: relative;
    flex: 1;
  }

  .secretInput {
    width: 100%;
    height: 40px;
    border-radius: 10px;
    border: 1px solid #e5e7eb;
    background-color: #f9fafb;
    padding: 0 44px 0 10px;
    outline: none;
    font-family: monospace;
    font-size: 14px;
    color: #111827;
  }

  .toggleSecret {
    position: absolute;
    right: 10px;
    top: 50%;
    transform: translateY(-50%);
    border: none;
    background: transparent;
    cursor: pointer;
    color: #6b7280;
    font-size: 12px;
    padding: 4px 6px;
  }
  .switch {
    margin-bottom: 12px;
  }
  .btn1 {
    height: 35px;
  }
  .scroll {
    overflow: auto;
    height: 125px;
  }
`;

export const Loader = styled.span`
  width: 68px;
  height: 68px;
  border: 5px solid #9ca3af;
  border-bottom-color: transparent;
  border-radius: 50%;
  display: block;
  box-sizing: border-box;
  animation: rotation 1s linear infinite;
  margin: 0 auto;

  @keyframes rotation {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;